import React, { PureComponent } from 'react'
import { Grid } from 'react-bootstrap'

class AccessReset extends PureComponent {
  render () {
    return (
      <div className="bg-auth-reset-password">
        <Grid>
          {this.props.children}
        </Grid>
      </div>
    )
  }
}
export default AccessReset
